"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.approvalQueue.title': 'Coda di approvazione',
    'socialMediaPlan.approvalQueue.desc': 'Post in attesa di revisione',
    'socialMediaPlan.approvalQueue.proposedDate': 'Data proposta:',
    'socialMediaPlan.approvalQueue.preview': 'Anteprima',
    'socialMediaPlan.approvalQueue.reject': 'Rifiuta',
    'socialMediaPlan.approvalQueue.approve': 'Approva',
    'socialMediaPlan.approvalQueue.rejectConfirm': 'Rifiutare questo post e spostarlo in bozze?',
    'socialMediaPlan.approvalQueue.approved': 'Post approvato per la pianificazione',
    'socialMediaPlan.approvalQueue.rejected': 'Post spostato nelle bozze',
};
